import React from "react";
import axios from "axios";

import { domain } from "../services/constants";
import { useGoogleLogin } from "@react-oauth/google";
import { async } from "q";
import { useDispatch } from "react-redux";
import { getUserDetails } from "../services/auth";
import { updateIsLoggedIn } from "../redux/slices/user";
import { closeModal } from "../redux/slices/formDetails";

export default function GoogleButton({ text }) {
  const dispatch = useDispatch();

  const handleGoogleLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      console.log(tokenResponse);
      let data = {
        client_id: process.env.REACT_APP_CLIENT_ID,
        client_secret: process.env.REACT_APP_CLIENT_SECRET,
        grant_type: "convert_token",
        backend: "google-oauth2",
        token: tokenResponse.access_token,
      };
      const res = await axios.post(`${domain}/social-auth/convert-token/`, data);
      let response_data = await res.data;
      localStorage.setItem("access", response_data.access_token);
      localStorage.setItem("refresh", response_data.refresh_token);
      localStorage.setItem("withGoogle", true);
      dispatch(updateIsLoggedIn(true));
      dispatch(closeModal());
      getUserDetails((err, userDetails) => {
        if (err) return;
        localStorage.setItem("userName", userDetails.data.name);
        localStorage.setItem("userEmail", userDetails.data.email);
        localStorage.setItem("userId", userDetails.data.id);
      });
    },
  });

  return (
    <div onClick={handleGoogleLogin} className="form_modal__btn-secondary btn-secondary">
      <img src="/assets/icons/google.svg" className="google-icon" alt="" />
      <p> {text}</p>
    </div>
  );
}
